import React, { useState, useMemo } from "react";
import { Tabs, Tab, Box } from "@mui/material";
import ForeCasterCommentsAndFiles from "../tabsModule/ForeCasterCommentsAndFiles";
import { useSelector } from "react-redux";
import { getTemplateType } from "../../../../../../utils/ForcasterUtils";
import {
  resetSharedUids,
  setMultiMetaSharedUid,
  setObjectSharedUid,
} from "../../../../../../features/genericCommentsAndFilesSlice";
import { useDispatch } from "react-redux";
//import AllForeCastsCommentsAndFiles from "../tabsModule/AllForeCastsCommentsAndFiles";

const ForecastTabs = () => {
  const [value, setValue] = useState(0);
  const dispatch = useDispatch();
  const forecasters = useSelector(
    (state: any) => state.forecasters?.forecastersList
  );
  const selectedForecastStatus = useSelector(
    (state: any) => state?.forecasters?.selectedForecastStatus
  );

  // Filter and sort forecasters based on selected status and creation date
  const filteredData = useMemo(() => {
    return (forecasters ?? [])
      .filter((forecaster: any) => {
        if (!selectedForecastStatus) return true;
        return forecaster?.status === selectedForecastStatus;
      })
      .sort((a: any, b: any) => {
        return new Date(b.created).getTime() - new Date(a.created).getTime();
      });
  }, [forecasters, selectedForecastStatus]);

  const templateLabels = useMemo(() => {
    return (
      filteredData?.map((forecast: any) => {
        const templateType = getTemplateType(forecast.template_type);
        return {
          label: `${templateType} ${forecast.version}`,
          meta_shared_id: forecast.meta_shared_uid,
        };
      }) || []
    );
  }, [filteredData]);

  const tabConfig = useMemo(() => {
    const sharedUids = templateLabels
      ?.map((label: any) => label.meta_shared_id)
      ?.reverse();
    return [
      {
        label: "ALL FORECASTS",
        meta_shared_id: "",
        component: () => (
          <ForeCasterCommentsAndFiles
            type="all"
            objectType="forecaster_meta"
            referenceModule="Forecaster"
            moduleType="forecaster"
            objectSharedUid={sharedUids.length ? sharedUids : []}
            postCommentTrackID="450"
            reactionTrackID="452"
            uploadFileTrackID="455"
            downloadFileTrackID="456"
            previewFileTrackID="519"
          />
        ),
      },
      ...templateLabels.map(({ label, meta_shared_id }: any) => ({
        label,
        meta_shared_id,
        component: () => (
          <ForeCasterCommentsAndFiles
            type="single"
            objectType="forecaster_meta"
            referenceModule="Forecaster"
            moduleType="forecaster"
            objectSharedUid={meta_shared_id}
            postCommentTrackID="450"
            reactionTrackID="452"
            uploadFileTrackID="455"
            downloadFileTrackID="456"
            previewFileTrackID="519"
          />
        ),
      })),
    ];
  }, [templateLabels]);

  // When switching tabs, reset shared UIDs and set appropriate UIDs based on selected tab
  const handleChange = (_: React.SyntheticEvent, newValue: number) => {
    dispatch(resetSharedUids());
    setValue(newValue);

    const selectedTab = tabConfig[newValue];
    if (newValue === 0) {
      // All Forecasts tab
      const sharedUids = templateLabels
        .map((l: any) => l.meta_shared_id)
        .reverse();
      dispatch(setMultiMetaSharedUid(sharedUids));
    } else {
      // Single Forecast tab
      dispatch(setObjectSharedUid(selectedTab.meta_shared_id));
    }
  };

  if (!forecasters || forecasters.length === 0 || tabConfig.length === 0) {
    return (
      <Box sx={{ p: 2, textAlign: "center" }}>
        <p>No forecasters available.</p>
      </Box>
    );
  }

  const ActiveComponent = tabConfig[value]?.component;

  return (
    <>
      <Box sx={{ bgcolor: "#fff" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="forecast modules"
          sx={{
            px: 2,
            "& .MuiTabs-indicator": {
              backgroundColor: "#7B1FA2",
            },
          }}
        >
          {tabConfig?.map((tab, index) => (
            <Tab
              key={index}
              label={tab.label}
              sx={{
                fontWeight: "bold",
                textTransform: "none",
                "&.Mui-selected": {
                  color: "#7B1FA2",
                },
              }}
            />
          ))}
        </Tabs>
      </Box>

      <Box sx={{ p: 2 }}>
        <ActiveComponent />
      </Box>
    </>
  );
};

export default ForecastTabs;
